
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.25 9.792l-1.057 1.097L10.5 8.097l-2.692 2.792L6.75 9.792 9.443 7 6.75 4.208 7.808 3.11 10.5 5.903l2.693-2.792 1.057 1.097L11.557 7l2.693 2.792zM16.5 0c.825 0 1.5.7 1.5 1.556v10.888C18 13.3 17.325 14 16.5 14H5.25c-.518 0-.923-.28-1.192-.692L0 7 4.058.684C4.328.272 4.732 0 5.25 0H16.5zm0 1.556H5.25L1.71 7l3.54 5.444H16.5V1.556z","fill":"#263238"}})])
          )
        }
      }
    